function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

function getDomPath(el) {
    var rightArrowParents = [];
    jQuery(this).parents().addBack().not('html').each(function () {
        var entry = this.tagName.toLowerCase();
        if (this.className) {
            entry += "." + this.className.replace(/ /g, '.');
        }
        rightArrowParents.push(entry);
    });
    return rightArrowParents.join(" ");
}

function call_posts(opt, update_pages = false) {

    let options = jQuery.extend({
        ajax_url: "//" + location.host + "/wp-admin/admin-ajax.php",
        action: 'news',
        per_page: 10,
        page: 1,
        list_container: null,
        list_pagination: null,
    }, opt);

    let container = jQuery(options.list_container);
    let pagination = jQuery(options.list_pagination);

    container.addClass('is-loading');

    jQuery.get(options.ajax_url, options, function (r) {

        if (pagination.length && container.length) {
            container.html(r.list_container);
            console.log('Container is Updated');
            if (update_pages) {
                pagination.html(r.list_pagination);
                console.log('Pages are Updated');
            }

            container.removeClass('is-loading');

            pagination.find('ul').not('.slick-initialized').slick({
                autoplay: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                adaptiveHeight: false,
                arrows: true,
                dots: false,
                infinite: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            swipe: true,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    }
                ],
            });

            // Update URL

          let _Query = clean({
                page: options.page,
                filter: options.filter,
                search: options.search,
            });

            window.history.replaceState({}, '', '?' + jQuery.param(_Query));


        }

    });

}

function SimpleFilter(_filter) {

    _filter = _filter.serializeArray();

    if(typeof(_filter) == "undefined" || _filter == null) {
        return '';
    }

    let _SEP_ID = '.';
    let _SEP_GROUP = '_';

    let _Group = {};
    let _URI = '';

    const groupBy = (array, key) => {
        // Return the end result
        return array.reduce((result, currentValue) => {
            if(currentValue.name.indexOf("all_") < 0){
                // If an array already present for key, push it to the array. Else create an array and push the object
                (result[currentValue[key]] = result[currentValue[key]] || []).push(
                    currentValue.value
                );
            }
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
        }, {}); // empty object is the initial value for result object
    };


    _Group = groupBy(_filter, 'name');
    jQuery.each(_Group,function (key, item) {
        _Group[key] = key + _SEP_ID + item.join(_SEP_ID);
    });


    _Group = jQuery.map(_Group, function(value, index) { return [value]; });
    _URI = _Group.join(_SEP_GROUP);

    return _URI;
}


function clean(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
            delete obj[propName];
        }
    }
    return obj
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.hash.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}